import _ from 'underscore';
import Backbone from 'backbone';
import $ from 'jquery';
import { state } from '../state-manager/state-model';
import { eventBus } from '../state-manager/event-bus';
import { renderBoundDataset } from '../utils/render-bound-dataset';
import { request } from '../utils/request';
import { handleError, ERRORS } from '../utils/handle-error';
// 모델
import { HiddenPchipModel } from './hidden-pchip/hidden-pchip-model';
import { RefillModel } from './refill/refill-model';
import { ClassMoneyModel } from './class-money/class-money-model';
// 뷰
import { ClassMoneyView } from './class-money/class-money-view';
import { ExcessView } from './excess/excess-view';
// 템플릿
import moneyTemplate from './side-popups/money-template.hbs';
import pchipTemplate from './side-popups/pchip-template.hbs';
import hiddenPchipTemplate from './hidden-pchip/hidden-pchip-template.hbs';
import hiddenPchipResultTemplate from './hidden-pchip/hidden-pchip-result-template.hbs';
import refillResultTemplate from './refill/refill-result-template.hbs';

export var UserInfoView = Backbone.View.extend({
  el: '.app__user-info',

  eventBus: eventBus,

  templates: {
    showMoney: moneyTemplate,
    showPchip: pchipTemplate,
    showHiddenPchip: hiddenPchipTemplate
  },

  initialize: function () {
    _.bindAll(
      this,
      'render',
      'handleUserAction',
      'openAttendance',
      'openTransfer',
      'openPmbonus',
      'depositPchip',
      'withdrawPchip',
      'hideAllPopups'
    );
    this.hiddenPchip = new HiddenPchipModel();
    this.refill = new RefillModel();
    this.classMoney = new ClassMoneyModel();

    this.on('refresh', this.refresh, this);

    this.listenTo(this.model, 'sync', this.render);
    this.listenTo(this.model, 'error', this.rescueError);

    this.listenTo(this.hiddenPchip, 'sync', this.renderHiddenPchipResult);
    this.listenTo(this.refill, 'sync', this.renderRefillResult);
    this.listenTo(this.classMoney, 'sync', this.renderMembershipMoneyResult);
  },

  events: {
    'click [data-user-action]': 'handleUserAction'
  },

  // Backbone.model 과 jQuery.ajax 에러 핸들러 형식
  rescueError: function (thisModel, jqXHR /*, syncOptions*/) {
    // userInfo는 자주 요청. 여기서 AJAX 에러가 난다면 대부분 로그인이 풀려서 에러
    // 일단은 에러 핸들러에 다 넘겨 버린다.
    handleError(jqXHR);
  },

  isNewUser: function () {
    if (state.get('nru')) {
      this.eventBus.trigger('show:newUser');
      return true;
    } else {
      return false;
    }
  },

  hideAllPopups: function () {
    this.$('[data-user-popup]').hide();
  },

  handleUserAction: function (e) {
    e.preventDefault();

    var $target = $(e.currentTarget);
    var actionName = $target.data('user-action');
    var context = this.model.toJSON();
    var rendered;

    // 머니보기, 내 손실머니보기 버튼은 nru일때 게임 실행 안내 팝업 띄워주기
    if (this.isNewUser() && actionName === 'showMoney') {
      this.eventBus.trigger('show:newUser');
    }

    // 피망캐쉬 충전하기는 점검 중에도 막지 않음
    if (state.get('maintenance') && actionName !== 'rechargePcash') {
      this.eventBus.trigger('show:maintenance');
      return;
    }

    if (_.isFunction(this.templates[actionName])) {
      // 템플릿이 있을 경우 팝업 렌더링
      rendered = this.templates[actionName](context);
      this.$('.app__user-info-popup').empty().html(rendered);
    } else if (_.isFunction(this[actionName])) {
      // 이 뷰의 인스턴스 메소드가 있을 경우 실행
      this[actionName].call(this, e);
    } else {
      console.info('Template or function name [', actionName, '] not found');
    }
  },

  render: function () {
    // NOTE: 성능상의 이유로, 전체 뷰를 렌더링 하지 않고, user-bind-XXX dataset 의 엘리먼트의 값들만 치환한다.
    var context = this.model.toJSON();
    renderBoundDataset(this.$el, 'user-bind', context);

    if (context.excessMoney > 0) {
      this.$el.find('[data-user-show=hasExcessMoney]').show();
    }
    if (context.excessPchip > 0) {
      this.$el.find('[data-user-show=hasExcessPchip]').show();
    }
    if (context.isBlocked > 0) {
      this.$el.find('[data-user-show=isBlocked]').show();
    }
    if (context.src) {
      // 프로파일 이미지도 갱신
      this.$('[data-user-profile-image]').attr('src', context.src);
    }
    return this;
  },

  refresh: function () {
    this.model.fetch({ game: state.get('game') });
    return this;
  },

  openMall: function (e) {
    this.eventBus.trigger('open:mall', e || { to: '' });
  },

  openMallClass: function () {
    this.openMall({ to: 'pokerclass' });
  },

  openAttendance: function () {
    this.eventBus.trigger('open:attendance');
  },
  openTransfer: function () {
    this.eventBus.trigger('open:transfer');
  },
  openPmbonus: function () {
    this.eventBus.trigger('open:pmbonus');
  },

  rechargePcash: function () {
    if (this.isNewUser()) {
      return;
    }

    var onSuccess = function (res) {
      var href = res.result.charge_url;
      this.eventBus.trigger('open:popup', {
        href,
        name: '_rds',
        width: 462,
        height: 190,
        onClose: _.bind(this.refresh, this)
      });
    };

    var onFail = function () {
      this.eventBus.trigger('handleError', ERRORS.GetRechargeLinkError);
    };

    request(state.get('game'), 'recharge-link')
      .done(_.bind(onSuccess, this))
      .fail(_.bind(onFail, this));
  },

  claimMembershipMoney: function (e) {
    e.preventDefault();
    this.classMoney.checkCanReceive();
  },

  renderMembershipMoneyResult: function () {
    var classMoney = new ClassMoneyView({ model: this.classMoney });
    $('.app__class-money').empty().html(classMoney.render().el);
  },

  depositPchip: function (e) {
    e.preventDefault();
    if (this.isNewUser()) {
      return;
    }

    this.hiddenPchip.deposit();
  },

  withdrawPchip: function (e) {
    e.preventDefault();
    this.hiddenPchip.withdraw();
  },

  renderHiddenPchipResult: function () {
    // NOTE: 간단하기 떄문에 Backbone 뷰를 만들지 않고, 템플릿 함수로 바로 렌더링한다.
    var resultView = hiddenPchipResultTemplate(this.hiddenPchip.toJSON());
    this.eventBus.trigger('show:message', {
      title: '히든 포커칩',
      message: resultView
    });
    this.hideAllPopups();
    this.refresh();
  },

  claimRefill: function () {
    if (this.isNewUser()) {
      return;
    }
    this.refill.claimRefill();
  },

  renderRefillResult: function () {
    // NOTE: 간단하기 떄문에 Backbone 뷰를 만들지 않고, 템플릿 함수로 바로 렌더링한다.
    var context = this.refill.toJSON();
    var resultView = refillResultTemplate(context);
    this.eventBus.trigger('show:message', {
      title: context.title,
      message: resultView
    });
    this.hideAllPopups();
    this.refresh();
  },

  showExcess: function (option) {
    var excess = new ExcessView({ model: this.model });
    var rendered = excess.render(option).el;
    this.$('.app__user-info-popup').empty().html(rendered);
    return this;
  },

  showExcessMoney: function () {
    if (this.model.get('game') === 'sudda') {
      return this.showExcess('moneySudda');
    }
    return this.showExcess('money');
  },

  showExcessPchip: function () {
    return this.showExcess('pchip');
  }
});
